// extracted by mini-css-extract-plugin
module.exports = {"page":"_13GDb","previous":"_1fmYv","first":"_2PrrW","next":"cp0dX","last":"LVYar","active":"_32SVr","activePage":"_2_Uae","large":"AP-1u","arrow":"_3Frc-","inner":"_zsW3"};